/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-cycle */
import _ from 'lodash';
import ApiService from './services/api.service';

/**
 * Base class for project data models
 * @property __className
 */
export default class Model {
  /**
   * Default model constructor
   * Take any input data and add it to the model
   * @param {Object | undefined} data
   */
  constructor(data) {
    this.__className = null;
    if (data) {
      const model = this;
      _.forEach(data, (value, key) => {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          model[key] = value;
        }
      });
    }
  }

  /**
   * Save updates via the Api Service.
   * Models should use named exports and an update{ModelName}(data) method needs to be
   * defined in /resources/assets/js/services/api.service.js
   * @returns {Promise<any>}
   * @throws Method is undefined
   */
  save() {
    if (this.__className === null) {
      throw Error('The model __className property must be set.');
    }

    const func = `update${this.__className}`;
    try {
      return Model.getApi()[func](this);
    } catch (e) {
      console.log(e);
      return undefined;
    }
  }

  /**
   * Get the Api service.
   * @returns {ApiService}
   */
  static getApi() {
    return new ApiService();
  }
}
